import type { MRT_ColumnDef } from "mantine-react-table-open";
import { Paragraph6EEGCreditResponseState } from "../../../../../types/api.types";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import { DATE_DISPLAY_FORMAT } from "../../../../../utils/dates/dates.constants";
import type { Paragraph6FinancialDocument } from "../../../Paragraph6.types";

function getPayDateColumn(): MRT_ColumnDef<Paragraph6FinancialDocument> {
  return {
    header: "Zahlungsdatum",
    accessorFn: (rowData) =>
      rowData.state === Paragraph6EEGCreditResponseState.paid
        ? backendDateOrDateTimeToLuxonDateTime(
            rowData.date_of_payment
          ).toJSDate()
        : undefined,
    filterVariant: "date-range",
    filterFn: (row, columnId, filterValue: [Date | null, Date | null]) => {
      // MRT's built-in date-range filter doesn't handle undefined; unpaid rows have an empty string -> value undefined
      const value = row.getValue<Date>(columnId);
      const [start, end] = [
        filterValue[0] ? new Date(filterValue[0]) : null,
        filterValue[1] ? new Date(filterValue[1]) : null
      ];

      if (!start && !end) return true;
      if (value === undefined) return false;
      if (start && value < start) return false;
      if (end && value > end) return false;
      return true;
    },
    mantineFilterDateInputProps: ({ rangeFilterIndex }) => ({
      placeholder: rangeFilterIndex === 0 ? "Von" : "Bis"
    }),
    Cell: ({ row }) => {
      if (row.original.state !== Paragraph6EEGCreditResponseState.paid) {
        return undefined;
      }
      return backendDateOrDateTimeToLuxonDateTime(
        row.original.date_of_payment
      ).toFormat(DATE_DISPLAY_FORMAT);
    }
  };
}

export { getPayDateColumn };
